import React from 'react';
import { Award, BoxArrowUpRight, MortarboardFill } from 'react-bootstrap-icons';
import AppBackButton from '../common/AppBackButton';
import './Dashboard.css';

const CERTIFICATE_APPLY_URL =
  process.env.REACT_APP_CERTIFICATE_APPLY_URL?.trim() || 'https://www.linkedin.com/learning/';

const CertificateProgram: React.FC = () => {
  return (
    <div className="v1-dashboard-page v1-learning-detail-page v1-webinar-page">
      <main className="v1-dashboard-main v1-webinar-main">
        <AppBackButton />
        <article className="v1-card v1-webinar-card v1-certificate-card">
          <div className="v1-webinar-card-accent v1-certificate-card-accent" aria-hidden />
          <div className="v1-webinar-card-inner">
            <p className="v1-webinar-eyebrow">Recommended certificate</p>
            <h1 className="v1-webinar-title">Certified Substation Engineer (CSE)</h1>
            <p className="v1-webinar-subtitle">
              Industry-recognized credential · Curriculum &amp; exam prep
            </p>

            <div className="v1-webinar-meta">
              <div className="v1-webinar-meta-tile">
                <MortarboardFill className="v1-webinar-meta-ico" aria-hidden />
                <div>
                  <div className="v1-webinar-meta-label">Aligns with</div>
                  <div className="v1-webinar-meta-value">Mid-Level Substation Engineer</div>
                </div>
              </div>
              <div className="v1-webinar-meta-tile">
                <Award className="v1-webinar-meta-ico" aria-hidden />
                <div>
                  <div className="v1-webinar-meta-label">Format</div>
                  <div className="v1-webinar-meta-value">
                    Self-paced &amp; instructor-led options
                  </div>
                </div>
              </div>
            </div>

            <p className="v1-webinar-body">
              Review prerequisites, exam structure, and enrollment. Connect this flow to your
              provider when you’re ready to take applications.
            </p>

            <div className="v1-webinar-actions">
              <a
                href={CERTIFICATE_APPLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="v1-btn v1-btn-primary v1-btn-icon v1-webinar-cta v1-webinar-external-cta"
              >
                Start application
                <BoxArrowUpRight className="v1-btn-lead-icon" aria-hidden />
              </a>
            </div>
          </div>
        </article>
      </main>
    </div>
  );
};

export default CertificateProgram;
